import React, { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";

import donation from "../../images/event-list/donation.svg";

const EventList = (props) => {
  const [donorFilter, setDonorFilter] = useState([]);

  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/eventlist/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    if (streamer[0] !== "") {
      let streamType = streamer[2],
        username = streamer[0],
        slug = streamer[1];

      /* Remove for production */
      props.overlayStore.socketConnect(
        streamType,
        username,
        slug,
        null,
        fake === "yes"
      );

      return () => props.overlayStore.socketDisconnect();

      // const queryString = window.location.search;
      // const urlParams = new URLSearchParams(queryString);
      // const event = urlParams.get('event');
    }
  }, []);

  const { donations, rewards, polls } = props.overlayStore;

  useEffect(() => {
    const donorList = donations.map((donation) => {
      return {
        id: donation.id,
        name: donation.donor_name,
        amount: donation.amount.value,
        comment: donation.donor_comment,
        rewardID: donation.reward_id === undefined ? 0 : donation.reward_id,
        pollID:
          donation.poll_option_id === undefined ? 0 : donation.poll_option_id,
      };
    });

    const rewardList = rewards.map((reward) => {
      return {
        rewardId: reward.id,
        rewardName: reward.name,
      };
    });

    const pollList = polls.map((poll) => {
      return {
        pollsID: poll.id,
        pollsName: poll.name,
        pollsOption: poll.options.map((option) => {
          return {
            optionId: option.id,
            optionName: option.name,
          };
        }),
      };
    });

    const pollOptionsList = pollList.reduce((optionsArray, poll) => {
      optionsArray.push(poll.pollsOption);
      return optionsArray;
    }, []);

    const optionsList = pollOptionsList.flatMap((x) => x);

    let causeList = [
      {
        causeId: "5bc5db5c-40a8-4306-a6a9-1592cbc8ab50",
        causeName: "Red Wagon for St. Jude",
      },
      {
        causeId: "a2997e00-1e0c-4eb9-b435-1ff5b2ab759b",
        causeName: "Art Supplies for St. Jude",
      },
      {
        causeId: "e98114f6-fe8c-41db-bf7f-c977e6d07803",
        causeName: "Family Meal Card for St. Jude",
      },
      {
        causeId: "0845427c-5979-4bd4-a223-2673d36ae25a",
        causeName: "No More Chemo Party",
      },
      {
        causeId: "b94bc9f8-7bf9-46a1-a683-a905b6ad0fcc",
        causeName: "2/3 Share of Chemotherapy Treatment",
      },
      {
        causeId: "b9d0d014-42f4-49b4-a230-8c4eb27db13e",
        causeName: "New Toy for Hospital Play Areas",
      },
      {
        causeId: "b12bef25-e5f3-4a27-b8b1-8271df77ffaf",
        causeName: "Share of Bone Marrow Treatment",
      },
    ];

    const donorResult = donorList.map((result) => {
      const rewardItem = rewardList.find(
        (rewardName) => rewardName.rewardId === result.rewardID
      );

      const causeItem = causeList.find(
        (causeName) => causeName.causeId === result.rewardID
      );

      const optionItem = optionsList.find(
        (optionName) => optionName.optionId === result.pollID
      );

      result.rewardName = rewardItem ? rewardItem.rewardName : null;
      result.causeName = causeItem ? causeItem.causeName : null;
      result.optionName = optionItem ? optionItem.optionName : null;

      return result;
    });

    setDonorFilter(donorResult.filter((donation) => donation.amount >= 0));
  }, [donations, polls]);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const listAmount = urlParams.get("listAmount");
  const orientation = urlParams.get("orientation");
  const align = urlParams.get("align");
  const color = urlParams.get("color");
  const incentives = urlParams.get("incentives");
  const fake = urlParams.get("fake");

  const truncateString = (str, num) => {
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  };

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };

  // console.log(donorFilter)

  return (
    <div className="event_list_wrapper ">
      <div
        className={
          "event_list " +
          orientation +
          `${orientation === "vertical" ? " " + align : ""}`
        }
      >
        <ul>
          {donorFilter.slice(0, listAmount).map((donor) => (
            <li key={donor.id}>
              <div className="event_list_container">
                <div className={"event_list_content " + color}>
                  {incentives === "yes" ? (
                    <div
                      className={
                        "event_list_icon" +
                        `${
                          donor.rewardID ===
                          "5bc5db5c-40a8-4306-a6a9-1592cbc8ab50"
                            ? " wagon "
                            : donor.rewardID ===
                              "a2997e00-1e0c-4eb9-b435-1ff5b2ab759b"
                            ? " art "
                            : donor.rewardID ===
                              "e98114f6-fe8c-41db-bf7f-c977e6d07803"
                            ? " food "
                            : donor.rewardID ===
                              "0845427c-5979-4bd4-a223-2673d36ae25a"
                            ? " nochemo "
                            : donor.rewardID ===
                              "b94bc9f8-7bf9-46a1-a683-a905b6ad0fcc"
                            ? " chemo "
                            : donor.rewardID ===
                              "b9d0d014-42f4-49b4-a230-8c4eb27db13e"
                            ? " toys "
                            : donor.rewardID ===
                              "b12bef25-e5f3-4a27-b8b1-8271df77ffaf"
                            ? " doctor "
                            : donor.rewardName
                            ? " reward "
                            : donor.optionName
                            ? " poll "
                            : " donation "
                        }` +
                        color
                      }
                    />
                  ) : (
                    <div className={"event_list_icon donation " + color} />
                  )}
                  <h1>
                    {orientation === "vertical"
                      ? truncateString(
                          donor.amount - Math.floor(donor.amount) !== 0
                            ? formatter.format(donor.amount)
                            : "$" +
                                formatNumber(donor.amount) +
                                " " +
                                donor.name,
                          20
                        )
                      : "$" + formatNumber(donor.amount) + " " + donor.name}
                  </h1>
                  {incentives === "yes" && (
                    <div className="incentive_claimed_wrapper">
                      {donor.rewardName ? (
                        <span>
                          {donor.rewardID ===
                            "5bc5db5c-40a8-4306-a6a9-1592cbc8ab50" ||
                          donor.rewardID ===
                            "5bc5db5c-40a8-4306-a6a9-1592cbc8ab50" ||
                          donor.rewardID ===
                            "e98114f6-fe8c-41db-bf7f-c977e6d07803" ||
                          donor.rewardID ===
                            "0845427c-5979-4bd4-a223-2673d36ae25a" ||
                          donor.rewardID ===
                            "b94bc9f8-7bf9-46a1-a683-a905b6ad0fcc" ||
                          donor.rewardID ===
                            "b9d0d014-42f4-49b4-a230-8c4eb27db13e" ||
                          donor.rewardID ===
                            "b12bef25-e5f3-4a27-b8b1-8271df77ffaf" ? (
                            ""
                          ) : (
                            <span>
                              <span className="incentive_claimed">Reward </span>
                              {truncateString(donor.rewardName, 25)}{" "}
                            </span>
                          )}
                        </span>
                      ) : (
                        ""
                      )}
                      {donor.causeName ? <span>{donor.causeName}</span> : ""}
                      {donor.optionName ? (
                        <span>
                          <span className="incentive_claimed">Poll</span>{" "}
                          {truncateString(donor.optionName, 35)}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default inject("overlayStore")(observer(EventList));
